const usageQuestions = [
    {
        title: "APP 是否可以免費使用？",
        content: <div>Workute 為免費下載使用，歡迎根據您的手機系統於 <a href='https://play.google.com/store/apps/details?id=com.google.android.apps.fitness&hl=zh_TW' target='_blank' rel='noopener noreferrer'>Google Play</a> / <a href='https://apps.apple.com/tw/app/workute-%E5%B1%85%E5%AE%B6%E9%81%8B%E5%8B%95%E8%B6%85%E8%90%8C%E5%A4%A5%E4%BC%B4/id1617026615' target='_blank' rel='noopener noreferrer'>APP Store</a> 進行下載。</div>
    },
    {
        title: "登出後，帳號是否會不見？",
        content: <div>登出後帳號不會不見，資料亦不會遺失，可以再使用相同帳號進行登入。若誤刪除帳號（非登出，是點選刪除帳號），請您立即 <a href='https://line.me/R/ti/p/@094kxmgj' target='_blank' rel='noopener noreferrer'>聯繫客服人員</a> 協助您。</div>
    },
    {
        title: "什麼是訪客登入與綁定帳號？",
        content: <div>若您是使用 Google 帳號或 Apple 帳號綁定登入，在您登出或是刪除 APP 時，可以再用已綁定的帳號重新登入，唯訪客模式不會有帳號紀錄，故一旦登出或是卸載 APP，會無法找回相關紀錄。</div>
    },
    {
        title: "使用 Workute 運動的影像，是否會被記錄？",
        content: <div>為保護用戶隱私，Workute 採用 AI 技術即時辨識動作準確度，僅於手機端進行偵測，並不會上傳雲端，或於系統中留下任何影像紀錄，即使企業承辦單位也不會看到您的運動過程，請放心使用。</div>
    },
    {
        title: "使用 Workute 運動時手機畫面黑屏？",
        content: <div>① 請先確認手機裡的應用程式資訊，是否有允許「相機」權限。<br/>② 請確認當前的「前鏡頭」功能是可以正常使用，並且當下網路連線皆為正常。</div>
    },
    {
        title: "使用 Workute 時是否需要配戴額外的穿戴裝置？",
        content: <div>使用 Workute 只需要有一支手機就可以！無需額外的裝置。無論手機或是平板，只要有前鏡頭可以進行動作偵測，就可以隨時隨地運動囉！</div>
    },
    {
        title: "使用 Workute 時，環境、服裝有需要留意的地方嗎？",
        content: <div>基本上是沒有太大限制的，不過還是建議避免在過度昏暗的環境、以及穿著過度寬鬆的衣服，例如：飛鼠袖、大寬褲等服裝。</div>
    },
    {
        title: "操作上遇到問題，是否有客服可以協助？",
        content: <div>如有任何需要協助的地方，歡迎傳訊息到 Workute 的官方 <a href='https://line.me/R/ti/p/@094kxmgj' target='_blank' rel='noopener noreferrer'>Line@</a>，我們會有真人客服為大家解惑。（服務時間：週一～週五 09:00-17:30，國定假日休）</div>
    },
    {
        title: "如何讓精靈進化？",
        content: <div>當您選擇 AI 動作來進行運動時，在運動中消耗的卡路里會變成軟糖，用軟糖餵養精靈，就可以使精靈再進化！（每隻精靈進化所需軟糖數不同）</div>
    },
    {
        title: "如何得到新的精靈？",
        content: <div>運動後，精靈隔天會生產神秘寶石，透過寶石就可以解鎖更多精靈囉！</div>
    },
    {
        title: "企業賽事結束後，拿到的精靈會不見嗎？",
        content: <div>不會的，只要是您搜集到的精靈，就會永遠屬於您，永遠成為您運動的最佳夥伴！</div>
    }
];

const planQuestions = [
    {
        title: "Workute 與其他運動 APP 有什麼不同？",
        content: <div>Workute 是為了健康促進而誕生，企業方案裡除了可以進行大家熟悉的步行賽之外，還有：<br/>① 創新 AI 動作賽事，徒手訓練 + AI 智能偵測，有效提升同仁健康<br/>② 遊戲化精靈養成，增進同仁對運動的樂趣與黏著度，培養永續運動力</div>
    },
    {
        title: "Workute 企業方案有包含什麼內容？",
        content: <div>【企業方案】：可舉辦兩大類型運動賽事並可做賽制安排（組隊/個人）、含管理後台、即時數據儀表板、一鍵生成 ESG 報告等功能，適合各種規模企業/團體使用。</div>
    },
    {
        title: "企業方案是否有後台可以管理賽事？是否有數據可以看？",
        content: <div>有的，凡訂閱企業方案者，皆配有企業管理後台，內包含賽事管理、即時數據、建立賽事、ESG 報告等功能。<br/>我們還有更多好用功能，<a href='https://www.surveycake.com/s/glOg2' target='_blank' rel='noopener noreferrer'>歡迎洽詢</a>。</div>
    },
    {
        title: "企業賽事結束後，同仁的運動數據會留存嗎？",
        content: <div>會的，同仁本身的 APP 上會保存運動記錄，訂閱期間企業管理後台也都可以針對歷史賽事&數據做查閱。</div>
    },
    {
        title: "Workute 如何協助企業實踐 ESG 員工關懷、環境永續目標？",
        content: <div>Workute 透過遊戲化、競賽機制提升員工運動意願，並導入生理數據對比功能，協助企業進行員工健康管理，真正促進員工健康。Workute 鼓勵用戶居家健身，減少外出使用交通工具而產生的碳排放，達到環境永續、減碳的企業 ESG 目標。</div>
    },
    {
        title: "我們公司有自己的吉祥物，可以客製成 APP 裡的精靈嗎？",
        content: <div>非常歡迎您來創造獨一無二的企業專屬精靈！如您的企業本身有吉祥物，都歡迎找我們製作專屬的吉祥物精靈。<br/><a href='https://www.surveycake.com/s/glOg2' target='_blank' rel='noopener noreferrer'>吉祥物精靈洽詢</a></div>
    },
    {
        title: "我們還想舉辦更多 EAP 課程，是否有相關課程？",
        content: <div>如您有更多 EAP 課程需求，我們有專業的合作講師&顧問，可以一起協助您，<a href='https://www.surveycake.com/s/glOg2' target='_blank' rel='noopener noreferrer'>歡迎洽詢</a>。</div>
    },
    {
        title: "欲使用企業方案，要怎麼訂購？費用如何計算？",
        content: <div>Workute 的企業方案，有單次訂閱與年訂閱可供選擇，無論您的企業規模大小、籌辦活動的形式，都歡迎與我們討論，找到最適合的方案。</div>
    },
    {
        title: "有實體活動需求，是否也有相關方案？",
        content: <div>Workute 除了線上舉辦活動，我們還提供線下工作坊，讓企業的活動可以從線上延伸到實體場域，因線下活動需求變化較多，歡迎來與我們討論。</div>
    },
    {
        title: "企業選擇 Workute 的原因",
        content: <div>▪ AI 偵測，即時回饋動作準確度：Workute 採用 AI 骨架偵測技術，開發各部位運動，不僅能隨時隨地鍛鍊，更確保動作確實做對，真正落實 ESG 員工關懷、獲得員工真實的運動數據。<br/>▪ 後台數據一目了然，專人帶領輕鬆開賽：後台員工健康數據一目了然、操作簡單，專人一步步帶領，零門檻輕鬆開賽！<br/>▪ 精靈養成機制，介面簡單好操作：遊戲化設計，邊玩邊運動，員工參與度高。介面簡單、直覺操作，員工接受度高。</div>
    },
    {
        title: "是否有任何資訊安全防護？",
        content: <div>每位 Workute 使用者與企業資料皆儲存於 Amazon RDS 加密資料庫保存，所有對伺服器的訪問都會經過軟、硬體防火牆、傳輸資料加密的層層防護以提供最優質的服務。<br/>為確保安全性和效能，系統將即時更新並定期進行安全性評估。<br/>緯詠智能也通過 ISO27001 資安認證，全面落實資安防護與個資保護。</div>
    }
];

const competitionQuestions = [
    {
        title: "如何加入企業賽事？",
        content: <div>企業建立了運動賽事之後，每一場賽事都會有專屬的 QRcode，同仁只要掃描 QRcode，並透過 email 或手機進行驗證，即可開始運動。</div>
    },
    {
        title: "加入企業賽事時收取不到驗證碼？",
        content: <div><strong>Email驗證：</strong><br/>① 請先確認您的 email 是否能正常收信（常見狀況：信箱已滿、有擋信等）<br/>② 請先確認是否有跑到垃圾信件匣裡<br/><br/><strong>手機驗證：</strong><br/>① 請先確認您的手機簡訊功能是否有阻擋廣告訊息<br/><br/>如仍無法收到信件，請傳訊息至 <a href='https://line.me/R/ti/p/@094kxmgj' target='_blank' rel='noopener noreferrer'>Line@</a> 客服</div>
    }
];

const stepCompetitionQuestions = [
    {
        title: "進行步行賽時是否要開著 APP 走路？",
        content: <div>Workute 的步行賽在進行時無需開啟 APP，僅需帶著裝置即可。（手機或者智慧型手錶配戴在身上即可）</div>
    },
    {
        title: "進行步行賽時是否要每天開啟 APP 手動上傳？",
        content: <div>無需手動上傳！我們會在您開啟 APP 時，自動上傳步數至 APP，這樣就不怕忘記！(建議還是可以每天打開 APP 確認步數）</div>
    },
    {
        title: "步行賽是否有不支援的穿戴裝置？",
        content: <div>只要您的穿戴裝置（如：智慧型手錶），可以同步 Google Fit (Android) / 健康 Health (iOS) 這兩個 APP，大部分都是可以的。<br/>（若遇特殊情況，請來訊 <a href='https://line.me/R/ti/p/@094kxmgj' target='_blank' rel='noopener noreferrer'>Line@</a> 客服）</div>
    },
    {
        title: "進行步行賽時，步數不同步",
        content: <div><strong>► Android 用戶</strong><br/>① Android 用戶請確認是否有安裝 Google Fit APP<br/>② 安裝完請確認，Workute 與 Google Fit 是否使用相同帳號登入<br/>③ 請確認 Workute 的設定，連結應用程式是否為「已連結」<br/>④ 以上步驟操作後，步數還未同步或連結失敗請依以下步驟操作：<br/>．先登出 Workute<br/>．到下方連結取消與連接(不會造成帳號資料遺失)<br/><a href='https://reurl.cc/o7qrKD' target='_blank' rel='noopener noreferrer'>https://reurl.cc/o7qrKD</a><br/>．再次登入 Workute<br/>（在計算步數與步數同步時會有些微時間差，請稍候再次確認。）<br/><br/><strong>► iOS 用戶</strong><br/>① iOS 用戶請確認健康 APP 是否有開啟步行權限給 Workute<br/>② 請確認 Workute 的設定，連結應用程式是否為「已連結」</div>
    }
];

const aiCompetitionQuestions = [
    {
        title: "AI 動作賽事裡的完成回合數指的是什麼？",
        content: <div>指的是有成功做完動作組數的回合數，例如：您選擇深蹲這個動作，運動強度設定輕量等級，他的目標次數是 15 下，也就是您要完成這 15 下，才算一回合。</div>
    },
    {
        title: "AI 動作賽事的動作可以訓練到哪些部位？",
        content: <div>AI 動作涵蓋了上肢、下肢、腿部、核心肌群及伸展等全身性的動作。</div>
    }
];

export {
    usageQuestions,
    planQuestions,
    competitionQuestions,
    stepCompetitionQuestions,
    aiCompetitionQuestions
};
